module.exports = __webpack_public_path__ + "img/EXPORT.de713f9f.svg";